import React from 'react';

const BS_Tables = () => {
    return (
        <div>
            <h1>BS_Tables Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Tables;
